
<template>
  <!--编辑商品-->
  <div>
    <x-tabula
      ref="table"
      apiOrigin="PHP"
      :rowOptLen="4"
      :dataSource="dataSource"
      rowKey="goods_id"
      :excludeResetKey="['warehouse_id']"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
    >
      <template slot="opt_o" slot-scope="{row}">
        <a class="goods-box" :href="row.goods_url" target="_blank">
          <img class="pic-box" :src="row.goods_img_url" alt="">

          <a-tooltip placement="topLeft" :title="row.goods_name">
            <span class="desc">{{row.goods_name.length > 33 ? `${row.goods_name.slice(0, 34)}...` : row.goods_name}}</span>
          </a-tooltip>
        </a>
      </template>
    </x-tabula>

    <!--推广的弹窗-->
    <a-modal
      title="推广"
      :visible="visible"
      @cancel="closeModal"
      @ok="visible=false"
      v-bind="$store.state.modalConfig"
    >
      <template slot="footer">
        <a-button type="primary" @click="closeModal">确定</a-button>
      </template>

      <a-form :form="form">
        <a-form-item v-bind="$store.state.modal_ItemLayout" label="平台">
          <a-radio-group @change="platFormChange" v-decorator="['platform', { initialValue: '1' }]">
            <a-radio value="1">iOS</a-radio>
            <a-radio value="2">Android</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item v-bind="$store.state.modal_ItemLayout" label="推广链接">
          <a-row type="flex" :gutter="10">
            <a-col span="18">
              <a-input id="share" v-model="urlObj.share_url" placeholder=""></a-input>
            </a-col>
            <a-col>
              <a-button class="share" data-clipboard-target="#share" type="primary">复制</a-button>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item v-bind="$store.state.modal_ItemLayout" label="领券链接">
          <a-row type="flex" :gutter="10">
            <a-col span="18">
              <a-input id="coupon" v-model="urlObj.coupon_url" placeholder=""></a-input>
            </a-col>
            <a-col>
              <a-button class="coupon" data-clipboard-target="#coupon" type="primary">复制</a-button>
            </a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </a-modal>

    <!--抓取链接的弹窗-->
    <a-modal
      :title="modalTitle"
      :visible="goodsVisible"
      @cancel="goodsVisible=false"
      @ok="submitHandle"
      :confirmLoading="btnLoading.loading"
      v-bind="this.$store.state.modalConfig"
    >
      <a-form :form="goodsForm">
        <a-form-item v-if="modalType === 'fetch'" v-bind="$store.state.modal_ItemLayout" label="选品库">
          <a-select v-decorator="['favorites_id', {rules: [{ required: true, message: '请选择选品库' }]}]" placeholder="请选择选品库">
            <a-select-option v-for="(item, index) of warehouseList" :key="index" :value="item.value">{{item.key}}</a-select-option>
          </a-select>
        </a-form-item>

        <template v-if="modalType === 'import'">
          <a-form-item v-bind="$store.state.modal_ItemLayout" label="平台">
            <a-select v-decorator="['platform', {rules: [{ required: true, message: '请选择平台' }]}]" placeholder="请选择平台">
              <a-select-option v-for="(item, index) of platformList" :key="index" :value="item.value">{{item.label}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item v-bind="$store.state.modal_ItemLayout" label="上传文件">
            <a-upload
              :beforeUpload="beforeUpload"
              :fileList="fileList"
              v-decorator="['file', {rules: [{ required: true, message: '请选择文件' }]}]"
              :accept="$store.state.excelAccept"
            >
              <a-button icon="upload" :loading="upLoading.loading">点击上传</a-button>
            </a-upload>
          </a-form-item>
        </template>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
import { upload } from 'ant-design-vue-admin-x';
import ClipboardJS from 'clipboard';
export default {
  mixins: [upload, fetchSelect],
  name: 'editGoods',
  data () {
    return {
      fileList: [],
      instance: {},
      urlObj: {
        share_url: '',
        coupon_url: ''
      },
      modalTitle: '',
      modalType: '',
      platformList: [],
      goodsVisible: false,
      btnLoading: { loading: false },
      warehouseList: [],
      urlData: {},
      visible: false,
      searchList: [
        { props: ['keywords'], placeholder: '标题', options: [], inputType: 'input' }
      ],
      searchParams: {
        keywords: undefined,
        warehouse_id: undefined
      },
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['community:editGoods:add'] },
        { text: '导入', icon: 'cloud-upload', permi: ['community:editGoods:import'], handle: () => this.importGoods('import') },
        { text: '淘宝抓取', icon: 'api', permi: ['community:editGoods:grab'], handle: () => this.fetchGoods('fetch') }
      ],
      rowOptList: [
        { text: '修改', handle: (record) => this.$refs.table.toEdit(record), permi: ['community:editGoods:edit'] },
        { text: '推广', handle: (record) => this.spreadGoods(record), permi: ['community:editGoods:spread'] },
        { text: '置顶', handle: (row) => this.goodsTop(row), permi: ['community:editGoods:top'] },
        { text: '删除', handle: (record) => this.$refs.table.showDeleteConfirm(record, record.community_name), permi: ['community:editGoods:remove'] }
      ],
      columns: [
        { title: '平台', dataIndex: 'platform_desc', align: 'left', width: '' },
        { title: '商品信息', dataIndex: '', align: 'left', width: '300px', scopedSlots: {customRender: 'o'} },
        { title: '价格', dataIndex: 'original_price', align: 'left', width: '' },
        { title: '优惠券', dataIndex: 'coupon_amount', align: 'left', width: '' },
        { title: '券后价', dataIndex: 'special_price', align: 'left', width: '' },
        { title: '月销量', dataIndex: 'sales_volume', align: 'left', width: '' },
        { title: '佣金', dataIndex: 'commission', align: 'left', width: '' },
        { title: '佣金比例(%)', dataIndex: 'commission_rate', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/market/share_goods',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addGoods',
        addTitle: '新增',
        editTitle: '修改'
      },
      deleteParam: {
        url: '/market/share_goods/',
        param: {pk_key: 'goods_id', pk_val: ''},
        title: '商品',
        key: 'goods_name'
      }
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
    this.goodsForm = this.$form.createForm(this);
  },
  created () {
    this.searchParams.warehouse_id = this.$route.query.id;
  },
  methods: {
    /** 打开导入弹窗 */
    importGoods (type) {
      this.modalType = type;
      this.modalTitle = '导入';
      this.fileData = '';
      this.fileList = [];

      this.typeSelect({
        query: 'market_platform_desc',
        handle: (res) => {
          this.platformList = res;
        }
      });
      this.goodsVisible = true;
    },
    /** 打开淘宝抓起弹窗 */
    fetchGoods (type) {
      this.modalType = type;
      this.modalTitle = '淘宝抓取';
      this._get({
        url: '/market/tb_goods_warehouse',
        params: {}
      }).then(({data}) => {
        this.warehouseList = data;
      });

      this.goodsVisible = true;
    },
    /** 确定窗口 */
    submitHandle () {
      this.goodsForm.validateFields((err, values) => {
        if (err) { return; }
        if (this.modalType === 'import') {
          this.requestImport(values);
        } else {
          this.requestFetch(values);
        }
      });
    },
    /** 上传前钩子 */
    beforeUpload (file, fileList) {
      this.fileData = file;
      this.fileList = fileList;
      return false;
    },
    /** 提交导入 */
    requestImport (values) {
      let formData = new FormData();
      formData.set('file', this.fileData);
      formData.set('warehouse_id', this.$route.query.id);
      formData.set('platform', values.platform);
      this._post({
        url: '/market/jd_import',
        params: formData
      }).then(({data}) => {
        this.$message.success('导入成功');
        this.goodsVisible = false;
        this.$refs.table.getTableList();
      });
    },
    /** 提交抓取 */
    requestFetch (values) {
      this._post({
        url: '/market/goods_grab',
        params: {
          warehouse_id: this.$route.query.id,
          ...values
        },
        btnLoading: this.btnLoading
      }).then(({data}) => {
        this.$message.success('抓取成功');
        this.goodsVisible = false;
        this.$refs.table.getTableList();
      });
    },
    /** 推广弹窗的平台切换 */
    platFormChange (e) {
      if (e.target.value === '1') {
        this.urlObj.share_url = this.urlData.ios_share_url;
        this.urlObj.coupon_url = this.urlData.ios_coupon_url;
      } else {
        this.urlObj.share_url = this.urlData.android_share_url;
        this.urlObj.coupon_url = this.urlData.android_coupon_url;
      }
    },
    /** 推广 */
    spreadGoods (record) {
      this.urlData = {
        android_share_url: '',
        android_coupon_url: '',
        ios_share_url: '',
        ios_coupon_url: ''
      };
      Object.keys(this.urlData).forEach((el) => {
        if (record.hasOwnProperty(el)) {
          this.urlData[el] = record[el];
        }
      });
      this.visible = true;
      this.$nextTick(() => {
        this.urlObj.share_url = this.urlData.ios_share_url;
        this.urlObj.coupon_url = this.urlData.ios_coupon_url;
        this.handleCopy('.share');
        this.handleCopy('.coupon');
      });
    },
    closeModal () {
      this.visible = false;
      for (let item in this.instance) {
        this.instance[item].destroy();
      }
    },
    /** 处理复制事件 */
    handleCopy (element) {
      this.instance[element] = new ClipboardJS(element);
      this.instance[element].on('success', (e) => {
        this.$message.success('已复制');
        e.clearSelection();
      });

      this.instance[element].on('error', (e) => {
        this.$message.error('复制失败');
      });
    },
    /** 商品顶置 */
    goodsTop (row) {
      this._post({
        url: '/market/goods_top',
        params: {
          goods_id: row.goods_id,
          warehouse_id: this.$route.query.id
        }
      }).then(({data}) => {
        this.$message.success('商品顶置成功');
        this.$refs.table.getTableList();
      });
    },
    /** 进入编辑商品页面 */
    toEditGoods (record) {
      this.$router.push({
        name: 'editGoods',
        query: { id: record.warehouse_id }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style lang="scss">
/*选品库信息*/
.goods-box {
  display: flex;
  align-items: center;
  flex:none;
  .pic-box {
    margin-right: 5px;
    width: 50px;
    height: 50px;
  }
  .desc {
    width: 244px;
    height: 44px;
  }
}
</style>
